import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { Button } from './ui/button';

export const PrivacyPolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-[#1e5a7a] text-white py-8">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="text-white hover:text-[#f5b800] mb-6"
          >
            <ArrowLeft className="mr-2" size={20} />
            Retour à l'accueil
          </Button>
          <div className="flex items-center gap-4">
            <Shield size={40} className="text-[#f5b800]" />
            <h1 className="text-4xl md:text-5xl font-bold">
              Politique de Confidentialité
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 space-y-8">
          
          <section>
            <p className="text-gray-600 mb-6">
              Dernière mise à jour : Mars 2025
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              IMMO CONCEPT ("nous", "notre", "nos") s'engage à protéger la confidentialité des visiteurs de notre site web. Cette politique de confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              1. Informations collectées
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Nous collectons les informations que vous nous fournissez directement, notamment :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Nom et prénom</li>
              <li>Adresse e-mail</li>
              <li>Numéro de téléphone</li>
              <li>Contenu des messages envoyés via notre formulaire de contact</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              2. Utilisation des informations
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Les informations collectées sont utilisées pour :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Répondre à vos demandes de renseignements</li>
              <li>Vous contacter concernant nos biens immobiliers et services</li>
              <li>Améliorer notre site web et nos services</li>
              <li>Respecter nos obligations légales</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              3. Protection des données
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données personnelles contre tout accès non autorisé, modification, divulgation ou destruction. Vos données sont stockées sur des serveurs sécurisés et ne sont accessibles qu'aux personnes autorisées.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              4. Partage des informations
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nous ne vendons, n'échangeons ni ne louons vos informations personnelles à des tiers. Nous pouvons partager vos informations uniquement dans les cas suivants :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mt-4">
              <li>Avec votre consentement explicite</li>
              <li>Pour respecter une obligation légale</li>
              <li>Avec nos prestataires de services (hébergement, email) sous contrat de confidentialité</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              5. Cookies
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Notre site utilise des cookies pour améliorer votre expérience de navigation. Les cookies sont de petits fichiers stockés sur votre appareil qui nous permettent de mémoriser vos préférences et d'analyser le trafic du site. Vous pouvez configurer votre navigateur pour refuser les cookies, mais certaines fonctionnalités du site pourraient ne pas fonctionner correctement.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              6. Vos droits
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Conformément à la loi suisse sur la protection des données (LPD) et au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
              <li>Droit d'accès à vos données personnelles</li>
              <li>Droit de rectification des données inexactes</li>
              <li>Droit à l'effacement de vos données</li>
              <li>Droit à la limitation du traitement</li>
              <li>Droit à la portabilité des données</li>
              <li>Droit d'opposition au traitement</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              7. Conservation des données
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Nous conservons vos données personnelles aussi longtemps que nécessaire pour les finalités décrites dans cette politique, sauf si une période de conservation plus longue est requise ou permise par la loi.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1e5a7a] mb-4">
              8. Contact
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits, vous pouvez nous contacter :
            </p>
            <div className="mt-4 p-6 bg-gray-50 rounded-xl">
              <p className="font-semibold text-[#1e5a7a]">IMMO CONCEPT</p>
              <p className="text-gray-700">Route de Berne 223</p>
              <p className="text-gray-700">1066 Épalinges, Suisse</p>
              <p className="text-gray-700 mt-2">
                Email : <a href="mailto:info@immoconceptsuisse.com" className="text-[#1e5a7a] hover:text-[#f5b800]">info@immoconceptsuisse.com</a>
              </p>
              <p className="text-gray-700">
                Téléphone : <a href="tel:+41795100855" className="text-[#1e5a7a] hover:text-[#f5b800]">+41 (0)79 510 08 55</a>
              </p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};
